/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
const INITIAL_STATE = {
  step: 1,
  userId: '',
  document: '',
  user: '',
  contactId: '',
};

const multiplosReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;
  if (type === 'TOGGLE_MULTIPLOS_STEP') {
    return {
      ...state,
      step: action.step,
    };
  }
  if (type === 'RESET_MULTIPLOS_STATE') {
    return {
      ...state,
      step: 1,
    };
  }
  if (type === 'MULTIMPLOS_GET_USER_ID') {
    return {
      ...state,
      userId: action.userId,
    };
  }
  if (type === 'MULTIPLOS_GET_USER_INFO') {
    return {
      ...state,
      user: action.user,
      document: action.document,
    };
  }
  if (type === 'MULTIPLOS_GET_CONTACT') {
    return {
      ...state,
      contactId: action.contactId,
      contact: action.contact,
    };
  }
  if (type === 'MULTIPLOS_GET_SITE_ID') {
    return {
      ...state,
      siteId: action.siteId,
    };
  }
  return {
    ...state,
  };
};

export default multiplosReducer;
